export default {
      id: "social-tg-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.svg#social-tg",
      toString: function () {
        return this.url;
      }
    }